import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useExam } from "@/context/exam-context";

// Pages that don't need prefetching
const publicPages = ['/', '/login', '/register'];

export function DataPrefetcher() {
  const location = useLocation();
  const { user } = useExam();
  
  // Basic route prefetching without requiring auth context
  useEffect(() => {
    // Only prefetch if user is authenticated
    if (!user) return;

    // Skip for public pages
    if (publicPages.includes(location.pathname)) {
      return;
    }
    
    // Note: Dynamic imports removed as they're not compatible with Vite
    // React Router will handle component loading automatically
    
  }, [location.pathname, user]);

  return null;
}

export default DataPrefetcher;